
import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import { getAdminUsers,addAdminUsers,updateAdminUsers,deActiveUsersAdmin,getAllRoles } from '../apiRequests/accessibilityRequest'

function* getAdminUsersHandler(action) {
  try {
    const response = yield call(getAdminUsers, action.params)
    yield put({
      type: types.GET_ADMIN_USER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_ADMIN_USER__ERROR,
      action: error,
    })
  }
}


function* addAdminUsersHandler(action) {
  try {
    const response = yield call(addAdminUsers, action.params)
    yield put({
      type: types.ADD_ADMIN_USER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.ADD_ADMIN_USER__ERROR,
      action: error,
    })
  }
}


function* updateAdminUsersHandler(action) {
  try {
    const response = yield call(updateAdminUsers, action.params)
    yield put({
      type: types.UPDATE_ADMIN_USER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_ADMIN_USER__ERROR,
      action: error,
    })
  }
}


function* deActiveAdminUsersHandler(action) {
  try {
    const response = yield call(deActiveUsersAdmin, action.params)
    yield put({
      type: types.UPDATE_ADMIN_USER_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.UPDATE_ADMIN_USER__ERROR,
      action: error,
    })
  }
}



function* getAllRolesHandler(action) {
  try {
    const response = yield call(getAllRoles, action.params)
    yield put({
      type: types.GET_ALL_ROLES_SUCCESS,
      action: response,
    })
  } catch (error) {
    yield put({
      type: types.GET_ALL_ROLES_ERROR,
      action: error,
    })
  }
}


function* watcherAdminUsersSaga() {
  yield takeEvery(types.GET_ADMIN_USER_REQUEST, getAdminUsersHandler)
  yield takeEvery(types.ADD_ADMIN_USER_REQUEST, addAdminUsersHandler)
  yield takeEvery(types.UPDATE_ADMIN_USER_REQUEST, updateAdminUsersHandler)
  yield takeEvery(types.DEACTIVE_ADMIN_USER_REQUEST, deActiveAdminUsersHandler)
  yield takeEvery(types.GET_ALL_ROLES_REQUEST, getAllRolesHandler)
}

export default watcherAdminUsersSaga